const __DEV__ = false;

import * as React from 'react';

function useImperativeState(initialValue) {
  var ref = React.useRef();
  if (!ref.current) {
    ref.current = typeof initialValue === 'function' ? initialValue() : initialValue;
  }
  return ref.current;
}

export { useImperativeState as default };
//# sourceMappingURL=use-imperative-state.js.map
